module.exports = __webpack_public_path__ + "img/08.1f6454c.jpg";